import React from 'react';
import { TextFieldElement } from 'react-hook-form-mui';
import * as yup from 'yup';

export const adoptionPacketDogsSchema = {
  adoptionPacketLinkDogs: yup.string().url('Adoption packet link must be a valid URL (including http:// or https://)'),
};

function AdoptionPacketsDogsPartial() {
  return (
    <TextFieldElement
      name="adoptionPacketLinkDogs"
      sx={{ marginTop: 2 }}
      fullWidth
      label="Adoption packet for dogs (optional)"
      variant="outlined"
      InputLabelProps={{ shrink: true }}
    />
  );
}

export default AdoptionPacketsDogsPartial;
